<button class="nav-item"
        cdkOverlayOrigin
        [ngClass]="{'minimised-state': isLukaMinimized() }"
        (click)="openLuka()"
>
    <span class="d-flex flex-row gap-8 align-items-center">
        <span class="icon-block">
            <img src="/assets/images/luka/luka-icon.svg" alt="" style="max-width: 30px;max-height:30px;">
            <!-- Comment the Not Activated Image Path -->
             <!-- <img src="/assets/images/luka/luka-autopilot.svg" alt="" style="max-width: 30px;max-height:30px;"> -->
            <span class="dot-16 bg-success-new minimised-icon"></span>
        </span>
        <span class="nav-label">LUKA</span>
    </span>
    <!-- Same User: Onboarding Flow : Code For Auto Pilot Activated Should be Shown Without Hovering -->


    <!-- Other User: Login Dashboard Flow: Code For Showing ASK LUKA -->
</button>

<ng-template cdkPortal>
    <app-luka-overlay [overlayInput]="botInputs()"
                      (overlayAction)="executeOverlayAction($event)"></app-luka-overlay>
</ng-template>

<ng-template #termsDialog>
    <div class="countable-dialog termsDialog" (click)="$event.stopPropagation()" style="width:776px; max-height: 660px;">
        <div mat-dialog-title class="dialog-header gap-4">
            <span class="badge badge-success badge-circle icon-bordered-success text-center">
                <i class="fa-regular fa-memo"></i>
            </span>
            <h4 class="title">{{ lucaInfo()?.title }}</h4>
            <p class="fs-14 fw-normal text-gray-6">{{ lucaInfo()?.updatedOn }}</p>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content class="dialog-body-content">
            @for (term of lucaInfo()?.terms; track $index) {
                <div class="flexbox-column gap-4">
                    <h6 class="title">{{ term?.header }}</h6>
                    @for (line of term?.text; track $index) {
                        <p>{{ line }}</p>
                    }
                </div>
            }

            <mat-checkbox [checked]="lucaInfo()?.isChecked" [disabled]="lucaInfo()?.showTermsOnly"
                          (change)="changeTerms($event)">
                I agree to the Terms and Conditions
            </mat-checkbox>
        </div>

        @if (!lucaInfo()?.showTermsOnly) {
            <div mat-dialog-actions class="dialog-footer justify-content-end pt-3">
                <button mat-button mat-stroked-button class="button-default flex-0" color="dark"
                        [mat-dialog-close]="false" style="min-width: 148px;">Cancel
                </button>
                <button class="flex-0 button-primary-gradient" [ngClass]="{'disabled': !(lucaInfo() && lucaInfo()?.isChecked) || (lucaInfo()?.showTermsOnly)}"
                        [mat-dialog-close]="true" style="min-width: 148px;">Proceed
                </button>
            </div>
        }
    </div>
</ng-template>

<ng-template #aiActivatedDialog>
    <div class="countable-dialog termsDialog" (click)="$event.stopPropagation()" style="width:400px;">
        <div mat-dialog-title class="dialog-header gap-12 align-items-center">
            <span> <img src="/assets/images/luka/luka-logo.svg" alt=""></span>
            <h4 class="title">Luka Activated Successfully</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
                 <p class="text-gray-7 text-center fw-medium">What you can do:</p>
        </div>
        <div mat-dialog-content class="dialog-body-content pt-3">
        
            <ul class="list-style-none flexbox-column gap-16 card p-3">
                @for (term of aiDisplayInfo(); track $index) {
                    <li class="flexbox-row flex-nowrap gap-8 align-items-baseline">
                        <i class="fa-regular fa-circle-check text-gradient"></i>
                        <p>{{ term }}</p>
                    </li>
                }
            </ul>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button class="button-primary-gradient"
                    [mat-dialog-close]="true">
                How It Works
            </button>
        </div>
    </div>
</ng-template>
